import { render, staticRenderFns } from "./MaskedLink.vue?vue&type=template&id=39890b54&scoped=true"
import script from "./MaskedLink.vue?vue&type=script&lang=js"
export * from "./MaskedLink.vue?vue&type=script&lang=js"
import style0 from "./MaskedLink.vue?vue&type=style&index=0&id=39890b54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39890b54",
  null
  
)

export default component.exports